import clsx from 'clsx'
import BaseParagraph, {
  ParagraphProps as BaseParagraphProps,
} from 'antd/lib/typography/Paragraph'

export interface ParagraphProps extends BaseParagraphProps {
  mute?: boolean
}

export const Paragraph = ({
  mute,
  className,
  ...rest
}: ParagraphProps): JSX.Element => (
  <>
    <BaseParagraph
      {...rest}
      className={clsx(className, { 'text-gray-400': mute })}
    />
  </>
)
